import encoding from './encoding-tool';
export default {
    /** @deprecated */
    arrayToString: encoding.utf16.fromUint16Array,
    /** @deprecated */
    base64ToUint8Array: encoding.base64.toUint8Array,
    /** @deprecated */
    arrayBufferToBase64: encoding.base64.fromUint8Array,
    /** @deprecated */
    stringToArray: encoding.utf16.toUint16Array,
};
